<template>
  <div class="">
    <div class="flex items-center gap-3 px-4 pt-4">
      <div>{{ t('apply_template') }}：</div>
      <selects
        v-model="selectFilter"
        :items="filtration.items"
        class="w-1/4"
        @change="setTemplate"
      >
        {{ t('apply_template') }}
      </selects>
    </div>
    <select-filter
      :data="filtration.data"
      :condition="condition"
      :disabled="props.disabled"
      @change="getFiltration"
    >
      <template #footer>
        <button
          class="border-round-btn disabled-btn"
          :disabled="props.disabled"
          @click="toTrialCalculation"
        >
          {{ t('trial_calculation_result_screening') }}
        </button>
      </template>
    </select-filter>
  </div>

  <modal v-if="showModel" v-model="showModel">
    <template #body>
      <div class="w-full p-4 xl:w-1/2">
        <div class="card-panel relative p-4">
          <button class="modal-close" @click="showModel = !showModel">
            <icon name="ic_common_close" class="h-5 w-5" />
          </button>
          <h3 class="mb-5 text-2xl">
            {{ t('trial_calculation_result') }}
          </h3>
          <table-filtrations
            v-if="showModel"
            v-model:loading="loading"
            :data="filtration.data"
            :filter-id="props.uuid"
            hide-toolbar
          />
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { ApiFiltrationsProfile, ApiFiltrationsList } from '@/api/filtrations.js';

import { conditionPool, trialCalculation } from '@/composables/audience.js';

import { useI18n } from 'vue-i18n';

import selectFilter from '@/components/filtrations/SelectFiltrations.vue';
import tableFiltrations from '@/components/filtrations/TableFiltrations.vue';
import modal from '@/components/Modal.vue';

import { ref, reactive, onBeforeMount, defineComponent } from 'vue';
export default defineComponent({
  name: 'MarketingActivitiesFilterTag',
  components: {
    selectFilter,
    tableFiltrations,
    modal
  },
  props: {
    uuid: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const { t } = useI18n();

    // use loading refresh table data
    const loading = ref(false);
    const showModel = ref(false);
    const selectFilter = ref(null);

    const filtration = reactive({
      data: [],
      outputData: [],
      items: []
    });

    const condition = reactive({
      tab: '',
      tabItems: [],
      poolAll: [],
      pool: []
    });

    onBeforeMount(async () => {
      const [filtrationsListData, conditionPoolData] = await Promise.all([
        ApiFiltrationsList({}),
        conditionPool()
      ]);
      if (!filtrationsListData.msg) {
        filtration.items = filtrationsListData.results.map((item) => ({
          text: item.name,
          value: item.uuid
        }));
      }

      const { tab, tabItems, poolAll, pool } = conditionPoolData;

      condition.tab = tab;
      condition.tabItems = tabItems;
      condition.poolAll = poolAll;
      condition.pool = pool;

      getProfile(props.uuid);
    });

    async function getProfile(uuid) {
      const form = {
        uuid
      };
      const data = await ApiFiltrationsProfile(form);
      if (!data.msg) {
        filtration.data = Array.isArray(data.data) ? data.data : [];
      }
    }

    async function toTrialCalculation() {
      const form = {
        uuid: props.uuid,
        data: filtration.outputData
      };

      const calculationData = await trialCalculation(form);
      if (!calculationData.msg) {
        loading.value = true;
        showModel.value = true;
      }
    }

    function getFiltration(data) {
      filtration.outputData = data;
      emit('change', data);
    }

    function setTemplate(key) {
      getProfile(key);
    }

    return {
      t,
      props,
      loading,
      showModel,
      selectFilter,
      filtration,
      condition,
      getFiltration,
      toTrialCalculation,
      setTemplate
    };
  }
});
</script>